import {
  ArrayInput,
  Button,
  maxLength,
  SimpleFormIterator,
  TextInput,
  useNotify,
  useRefresh,
  useSimpleFormIteratorItem,
} from "react-admin";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import { Grid, Typography } from "@mui/material";

import { settings } from "app";
import { erasmusRequests } from "api/erasmusApi";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";

const INTERNSHIPS_SOURCE = "internships";

// One row per internship of the student - the backend rejects a list that does not cover them all,
// so rows cannot be added or removed here. The reason itself is optional.
const InternshipRejectionIteratorItem = ({ internships }) => {
  const { index } = useSimpleFormIteratorItem();

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
      >
        <Typography color="primary">{internships?.[index]?.name}</Typography>
      </Grid>
      <Grid
        item
        xs={12}
      >
        <TextInput
          source="reason"
          label="Причина за отказ"
          sx={settings.style.textAria}
          variant="outlined"
          fullWidth
          multiline
          minRows={3}
          validate={maxLength(500)}
        />
      </Grid>
    </Grid>
  );
};

const CoordinatorRejectDialog = ({ id, internships = [] }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const defaultValues = {
    [INTERNSHIPS_SOURCE]: internships.map(internship => ({
      internshipId: internship?.id,
      reason: null,
    })),
  };

  const handleReject = async data => {
    const payload = {
      internships: data[INTERNSHIPS_SOURCE].map(internship => ({
        internshipId: internship.internshipId,
        reason: internship.reason?.trim() || null,
      })),
    };

    await dataProvider.customRequest(erasmusRequests.rejectIncomingInternshipStudentByCoordinator(id), payload, "PUT");
    notify("Успешен отказ на стаж", { type: "success" });
    refresh();
  };

  if (!internships.length) return null;

  return (
    <FormModal
      titleContent="Отказ от координатор"
      dialogSize="md"
      defaultValues={defaultValues}
      onConfirm={handleReject}
      triggerButton={
        <Button
          label="Откажи"
          variant="contained"
          startIcon={<ThumbDownIcon />}
        />
      }
    >
      <ArrayInput
        source={INTERNSHIPS_SOURCE}
        label={false}
        fullWidth
      >
        <SimpleFormIterator
          inline={false}
          disableAdd
          disableRemove
          disableReordering
          sx={settings.style.iteratorWithoutGap}
        >
          <InternshipRejectionIteratorItem internships={internships} />
        </SimpleFormIterator>
      </ArrayInput>
    </FormModal>
  );
};

export default CoordinatorRejectDialog;
